import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './i18';
import App from './App';
import reportWebVitals from './reportWebVitals';
import GlobalLoadingProvider from './GlobalLoadingProvider';

if (process.env.NODE_ENV === 'production') {
    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
    console.debug = () => {};
    console.info = () => {};
    console.trace = () => {};
}

const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
const savedTheme = localStorage.getItem('theme') || (prefersDark ? 'dark' : 'light');
document.documentElement.setAttribute('data-theme', savedTheme);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render( 
    <React.StrictMode>
        <GlobalLoadingProvider >
            <App />
        </GlobalLoadingProvider> 
    </React.StrictMode>
);


reportWebVitals();